export const codeOk = 200;
export const codeCreate = 201;
export const codeError = 400;
